import { Skeleton } from "@mui/material";

const ESQUELETO_KEYS_AUDITORIA_GRUPO = [
	"esqueleto-auditoria-grupo-01",
	"esqueleto-auditoria-grupo-02",
	"esqueleto-auditoria-grupo-03",
	"esqueleto-auditoria-grupo-04",
] as const;

/** Skeleton da timeline de auditoria do grupo (modal). */
export default function EsqueletoAuditoriaGrupo() {
	return (
		<div className="flex flex-col gap-3 px-2 py-2">
			{ESQUELETO_KEYS_AUDITORIA_GRUPO.map((key) => (
				<Skeleton key={key} variant="rounded" height={84} />
			))}
		</div>
	);
}
